// Evaluated before the selection is first written: it takes over the preferences stored with it
import { legacyPersistedStateKey } from '~/composables/usePersistedPreferences';
import defineStoreFromModule from '~/store/defineStoreFromModule';

import auth from '~/store/modules/auth';
import changeovers from '~/store/modules/changeovers';
import commands from '~/store/modules/commands';
import dashboard from '~/store/modules/dashboard';
import dashboardCycles from '~/store/modules/dashboardCycles';
import devices from '~/store/modules/devices';
import events from '~/store/modules/events';
import factories from '~/store/modules/factories';
import favorites from '~/store/modules/favorites';
import module from '~/store/modules/module';
import navigation from '~/store/modules/navigation';
import notifications from '~/store/modules/notifications';
import recurringEvents from '~/store/modules/recurringEvents';
import snackbars from '~/store/modules/snackbars';

export const useAuthStore = defineStoreFromModule('auth', auth);
export const useChangeoversStore = defineStoreFromModule('changeovers', changeovers);
export const useCommandsStore = defineStoreFromModule('commands', commands);
export const useDashboardStore = defineStoreFromModule('dashboard', dashboard);
export const useDashboardCyclesStore = defineStoreFromModule('dashboardCycles', dashboardCycles);
export const useDevicesStore = defineStoreFromModule('devices', devices);
export const useEventsStore = defineStoreFromModule('events', events);
export const useFactoriesStore = defineStoreFromModule('factories', factories);
export const useFavoritesStore = defineStoreFromModule('favorites', favorites);
export const useModuleStore = defineStoreFromModule('module', module);
export const useNavigationStore = defineStoreFromModule('navigation', navigation, {
  // Same key and format as vuex-persistedstate, so users keep their selection
  persist: {
    key: legacyPersistedStateKey(window.location.hostname),
    pick: ['machineSelected', 'groupSelected', 'factorySelected', 'periodTypeSelected'],
    serializer: {
      serialize: (selection) => JSON.stringify({ navigation: selection }),
      deserialize: (value) => JSON.parse(value).navigation ?? {},
    },
  },
});
export const useNotificationsStore = defineStoreFromModule('notifications', notifications);
export const useRecurringEventsStore = defineStoreFromModule('recurringEvents', recurringEvents);
export const useSnackbarsStore = defineStoreFromModule('snackbars', snackbars);
